import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/transport',
  component: layout,
  meta: {
    funcID: 'F0009',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'containerSet',
      name: `${pre}containerSet`,
      meta: {
        ...meta,
        head: { back: false },
        title: '集装箱箱型设置',
        funcID: 'F000901',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/containerset'),
    },
    {
      path: 'pendingOrderBatch',
      name: `${pre}pendingOrderBatch`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待处理订单批次',
        funcID: 'F000902',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/pendingorderbatch'),
    },
    {
      path: 'shipment',
      name: `${pre}shipment`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待分柜发运记录',
        funcID: 'F000903',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipment'),
    },
    {
      path: 'shipment/:pageType/:code?',
      name: `${pre}shipment-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '待分柜发运记录'
        },
        funcID: 'F000903',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipment/detail'),
    },
    {
      path: 'wait-booking',
      name: `${pre}wait-booking`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待订舱发运记录',
        funcID: 'F000904',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/wait-booking'),
    },
    {
      path: 'wait-booking/:pageType/:code?',
      name: `${pre}wait-booking-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '待订舱发运记录'
        },
        funcID: 'F000904',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/wait-booking/detail'),
    },
    {
      path: 'wait-exportDeclaration',
      name: `${pre}wait-exportDeclaration`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待报关发运记录',
        funcID: 'F000905',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/waitexportDeclaration'),
    },
    {
      path: 'wait-exportDeclaration/:pageType/:code?',
      name: `${pre}wait-exportDeclaration-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '待报关发运记录'
        },
        funcID: 'F000905',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/waitexportDeclaration/detail'),
    },
    {
      path: 'wait-productionLoad',
      name: `${pre}wait-productionLoad`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待产装运输发运记录',
        funcID: 'F000906',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/waitProductionLoad'),
    },
    {
      path: 'wait-productionLoad/:pageType/:code?',
      name: `${pre}wait-productionLoad-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '待产装运输发运记录'
        },
        funcID: 'F000906',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/waitProductionLoad/detail'),
    },
    {
      path: 'wait-shipment',
      name: `${pre}wait-shipment`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待清关/议付发运记录',
        funcID: 'F000907',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/waitshipment'),
    },
    {
      path: 'wait-shipment/:pageType/:code?',
      name: `${pre}wait-shipment-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '待清关/议付发运记录'
        },
        funcID: 'F000907',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/waitshipment/detail'),
    },
    {
      path: 'wait-settlement',
      name: `${pre}wait-settlement`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待结算发运记录',
        funcID: 'F000908',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/waitsettlement'),
    },
    {
      path: 'wait-settlement/:pageType/:code?',
      name: `${pre}wait-settlement-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '待结算发运记录'
        },
        funcID: 'F000908',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/waitsettlement/detail'),
    },
    {
      path: 'shipperConsignee',
      name: `${pre}shipperConsignee`,
      meta: {
        ...meta,
        head: { back: false },
        title: '收发货人信息维护',
        funcID: 'F000909',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipperConsignee'),
    },
    {
      path: 'shipperConsignee/:pageType/:code?',
      name: `${pre}shipperConsignee-detail`,
      meta: {
        ...meta,
        title: '收发货人信息维护',
        funcID: 'F000909',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipperConsignee/detail'),
    },
    {
      path: 'hscode',
      name: `${pre}hscode`,
      meta: {
        ...meta,
        head: { back: false },
        title: 'HSCODE编码维护',
        funcID: 'F000910',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/hscode'),
    },
    {
      path: 'dashboard',
      name: `${pre}dashboard`,
      meta: {
        ...meta,
        head: { back: false },
        title: '运输跟踪看板',
        funcID: 'F000911',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/dashboard')
    },
    {
      path: 'allShipment',
      name: `${pre}allShipment`,
      meta: {
        ...meta,
        head: { back: false },
        title: '发运记录汇总查询',
        funcID: 'F000912',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/allShipment'),
    },
    {
      path: 'allShipment/:pageType/:code?',
      name: `${pre}allShipment-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '发运记录汇总查询'
        },
        funcID: 'F000912',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/allShipment/detail'),
    },
    {
      path: 'shipmentPayStatement',
      name: `${pre}shipmentPayStatement`,
      meta: {
        ...meta,
        head: { back: false },
        title: '外运单费用结算',
        funcID: 'F000913',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipmentPayStatement'),
    },
    {
      path: 'shipmentPayStatement/:pageType/:code?',
      name: `${pre}shipmentPayStatement-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentPayStatementNo = '' } = $route.query || {}
          return shipmentPayStatementNo || '外运单费用结算'
        },
        funcID: 'F000913',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/shipmentPayStatement/detail'),
    },
    {
      path: 'shipmentPayStatementReview',
      name: `${pre}shipmentPayStatementReview`,
      meta: {
        ...meta,
        head: { back: false },
        title: '外运单费用结算审核',
        funcID: 'F000915',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipmentPayStatementReview'),
    },
    {
      path: 'shipmentPayStatementReview/:code',
      name: `${pre}shipmentPayStatementReview-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentPayStatementNo = '' } = $route.query || {}
          return shipmentPayStatementNo || '外运单费用结算审核'
        },
        funcID: 'F000915',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/shipmentPayStatementReview/detail'),
    },
    {
      path: 'shipmentExpense',
      name: `${pre}shipmentExpense`,
      meta: {
        ...meta,
        head: { back: false },
        title: '发运单费用填报',
        funcID: 'F000914',
        PID: 'F00',
      },
      component: () => import('@/views/factory/transport/shipmentExpense'),
    },
    {
      path: 'shipmentExpense/:pageType/:code?',
      name: `${pre}shipmentExpense-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentExpenseNo = '' } = $route.query || {}
          return shipmentExpenseNo || '发运单费用填报'
        },
        funcID: 'F000914',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/transport/shipmentExpense/detail'),
    },
    {
      path: 'customer/setting',
      name: `${pre}customerSetting`,
      meta: {
        ...meta,
        head: { back: false },
        title: '客户配置维护',
        funcID: 'F000916',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/customersetting')
    },
    {
      path: 'customer/setting/:pageType/:code?',
      name: `${pre}customerSetting-detail`,
      meta: {
        ...meta,
        title: '客户配置维护详情',
        funcID: 'F000916',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/customersetting/detail')
    },
    {
      path: 'freightScmDeduction',
      name: `${pre}freightScmDeduction`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000917',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/freightScmDeduction')
    },
    {
      path: 'freightScmDeduction/:pageType/:code?',
      name: `${pre}freightScmDeduction-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { freightDeductionNo = '' } = $route.query || {}
          return freightDeductionNo || '供应商运费扣款'
        },
        funcID: 'F000917',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/freightScmDeduction/detail')
    },
    {
      path: 'dispatchedWaybillQuery',
      name: `${pre}dispatchedWaybillQuery`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000918',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/dispatchedWaybillQuery')
    },
    {
      path: 'shipmentDetailQuery',
      name: `${pre}shipmentDetailQuery`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000919',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/shipmentDetailQuery')
    },
    {
      path: 'factoryShipmentDetailQuery',
      name: `${pre}factoryShipmentDetailQuery`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000920',
        PID: 'F00'
      },
      component: () => import('@/views/factory/transport/factoryShipmentDetailQuery')
    },
  ])('transport-'),
}
